module.exports = __webpack_public_path__ + "static/img/y22.7f975d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y22.jpg
// module id = asTq
// module chunks = 1